import { useEffect } from "react";
import { getPaymentsRequest } from "../../../redux/action/index.js";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";
import { RequestCard } from "../../../components/Cards/RequestCard.js";
import {
  AdminSideNav,
  AuthNav,
} from "../../../components/Navbar/Webpages/AuthNav.jsx";
import { CashIcon } from "@heroicons/react/outline";

const Payment = () => {
  const dispatch = useDispatch();

  const { user, getPaymentsError, payments, getPaymentsLoading } = useSelector(
    (state) => {
      const {
        errors: { getPayments: getPaymentsError },
      } = state.ajaxStatuses;
      const { getPaymentsLoading } = state.loadingIndicator;
      const { user } = state.userData;
      const { payments } = state.paymentData;

      return {
        user,
        getPaymentsError,
        payments,
        getPaymentsLoading,
      };
    }
  );

  useEffect(() => {
    dispatch(getPaymentsRequest(user._id));
  }, [dispatch, user._id]);

  useEffect(() => {
    if (getPaymentsError) toast.error(getPaymentsError);
  }, [getPaymentsError]);

  return (
    <div className="bg-gray-50 min-h-screen ">
      <AuthNav title={"Deposite/Withdrawal Requests"} />
      <AdminSideNav />

      <div className="container max-w-3xl mx-auto px-4 py-8 mb-20 pt-24">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="p-3 bg-white rounded-full shadow-sm text-primary">
            <CashIcon className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-2xl font-heading font-bold text-gray-900">
              Transaction Requests
            </h1>
            <p className="text-sm text-gray-500 font-body">
              Manage pending deposits and withdrawal requests
            </p>
          </div>
        </div>

        {getPaymentsLoading ? (
          <div className="flex flex-col items-center justify-center py-32">
            <CircularProgress size={40} style={{ color: "#4F46E5" }} />
            <p className="mt-4 text-gray-500 font-medium">
              Loading transactions...
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {payments.length === 0 ? (
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 text-center">
                <h3 className="text-lg font-heading font-bold text-gray-900">
                  No Transactions Found
                </h3>
                <p className="text-gray-500 mt-2">
                  There are no pending requests to process.
                </p>
              </div>
            ) : (
              payments.map((data, index) => (
                <RequestCard
                  key={index}
                  data={data}
                  getPaymentsRequest={getPaymentsRequest}
                />
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;
